/* globals Choices */
'use strict';

const actualBtn = document.querySelectorAll('.ginput_container_fileupload .large');
const fileUpload = document.querySelectorAll('.gform_fileupload');
const actual = document.querySelector('.ginput_container_fileupload .large');


const uploadContainer = document.querySelector('.ginput_container_fileupload');

const fileChosen = document.querySelector('.gform_fileupload_rules');

fileUpload.forEach((this_item, i) => {
    let _this = fileUpload[i];

    // Real input
    let realInput = _this.querySelector('.ginput_container_fileupload .gform_button_select_files');
    let previewList = _this.querySelector('.ginput_preview_list');
    let realInputId = realInput.id;

    // Create Fake button and remove button
    let button = document.createElement('label');
    let buttonText = document.createElement('span');
    let removeBtn = document.createElement('i');
    let uploadIcon = document.createElement('i');

    // Assign classes for buttons
    removeBtn.classList.add('remove-file', 'fas', 'fa-trash');
    button.classList.add('btn', 'btnSecondary', 'btnReflect');
    uploadIcon.classList.add('fas', 'fa-file-arrow-up', 'upload__icon');
    buttonText.innerText = 'Pievienot failu';

    // Assign icons and label for buttons
    button.setAttribute("for", realInputId);
    button.append(uploadIcon, buttonText, removeBtn);

    realInput.parentNode.insertBefore(button, realInput);

    realInput.addEventListener('change', function(){
        _this.classList.add('active');
        if (this.files[0].name !== "" || this.files[0].name !== undefined) {
            buttonText.innerText = this.files[0].name;
        }
    });

    previewList.addEventListener('DOMNodeInserted', function(){
        if (!previewList.classList.contains('ginput_preview_list--has-items')) {
            previewList.classList.add('ginput_preview_list--has-items');
            _this.classList.add('gform_fileupload--has-items');
        }
    });
    // realInputTwo.addEventListener('change', function(){
    //     console.log(previewList.innerHTML());
    // });

    removeBtn.addEventListener('click', function(e){
        e.preventDefault();
        buttonText.innerText = 'Pievienot failu';
        _this.classList.remove('active');
        realInput.value = '';
    });
});


// Choices
// var select = document.querySelectorAll('select');

// select.forEach(item => {
//     new Choices(item, {
//         searchEnabled: false,
//         itemSelectText: '',
//         shouldSort: false,
//       });
// });